import { For, createSignal, onCleanup } from 'solid-js';
import { date } from 'common';
import styles from '../st-attendance-grid.module.css';

export interface MonthHeadingProps {
    excludeWeekend?: boolean;
}

export function MonthHeading(props: MonthHeadingProps) {
    let start = date.startOfWeek(date.today());
    const days = !!props.excludeWeekend
        ? [1, 2, 3, 4, 5].map(i => date.addDays(start, i))
        : [0, 1, 2, 3, 4, 5, 6].map(i => date.addDays(start, i));

    const [dateFormat, setDateFormat] = createSignal<'long' | 'short' | 'narrow'>('long');

    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            const { width } = entry.contentRect;
            setDateFormat(width < 80 ? 'short' : 'long');
        }
    });

    onCleanup(() => resizeObserver.disconnect());

    function init(el: HTMLDivElement) {
        resizeObserver.observe(el);
    }

    return (
        <For each={days}>{d =>
            <div ref={init} class={styles['month-heading-day']}>
                {Intl.DateTimeFormat('en-US', { weekday: dateFormat() }).format(d)}
            </div>
        }</For>
    );
}
